import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateProps } from '../../../../stores/newsfeed/actions';
import { Card, CardText, LinearProgress } from 'material-ui';
import R from 'ramda';
import DropzoneWithPreview from '../../../extra/dropzone-with-preview/dropzone';
import FilePreview from '../../../extra/filePreview/container';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const UploadFiles = props => {
  const {
    expanded,
    onCardExpand,
    updateProp,
    selectedFiles,
    savingPost,
    uploadingFile,
    selectedFilesNotFromMM,
  } = props;

  return (
    <Card
      expanded={expanded}
      onExpandChange={savingPost ? null : onCardExpand}
      style={{ boxShadow: 'none', borderTop: '1px solid #e0e0e0' }}
    >
      <CardText expandable style={{ padding: '0 30px' }}>
        <div style={{ marginTop: '10px' }}>
          <DropzoneWithPreview
            addFilesMessage="Drag and drop files here to upload"
            acceptedFileTypes=".jpg, .png, .jpeg, .mp4, .pdf"
            arrayOfPhotoTypes={[
              'image/jpeg',
              'image/png',
            ]}
            arrayOfAcceptedFileTypes={[
              'image/jpeg',
              'image/png',
              'video/mp4',
              'application/pdf']}
            addRemoveLinks={false}
            showFiletypeIcon={false}
            allFiles={selectedFiles}
            showThumbnailPreviews={false}
            uploadingFile={() => updateProp({ uploadingFile: true })}
            suggestedMinFileSize="50"
            finishedFileUploadCB={(imageUrl, fileType, fileName, fileSize) => {
              selectedFiles.unshift({
                url: imageUrl,
                mediaType: fileType,
                name: fileName,
                size: fileSize,
                created_at: new Date(),
              });
              updateProp({
                selectedFiles,
                uploadingFile: false,
              });
            }}
          />
          {uploadingFile && <LinearProgress mode="indeterminate" />}
        </div>
        {
          !isNilOrEmpty(selectedFilesNotFromMM) &&
            <div style={{ marginTop: '10px', overflowY: 'scroll', height: '150px', display: 'flex' }}>
              <FilePreview
                showFileName
                files={selectedFilesNotFromMM}
                removeFile={fileUrl => updateProp({ selectedFiles: selectedFiles.filter(object => object.url !== fileUrl) })}
              />
            </div>
        }
      </CardText>
    </Card>
  );
};

UploadFiles.propTypes = {
  expanded: PropTypes.bool,
  onCardExpand: PropTypes.func,
  updateProp: PropTypes.func,
  selectedFiles: PropTypes.array,
  savingPost: PropTypes.bool,
  uploadingFile: PropTypes.bool,
  selectedFilesNotFromMM: PropTypes.array,
};

const mapStateToProps = ({ newsfeed }) => ({
  selectedFiles: newsfeed.get('selectedFiles').toJS(),
  savingPost: newsfeed.get('savingPost'),
  uploadingFile: newsfeed.get('uploadingFile'),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadFiles);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/newPost/uploadFiles.jsx